<template>
  <div class="contentView__works" ref="contents">
    <div class="swiper-prev-btn" @click="btnEvent('prev')">
      <img class="icon" :src="images.more_left">
    </div>
    <div class="swiper-items">
      <div class="swiper-item" v-for="(item, index) in data" :key="item.pk">
          <WorkItem :dic="item" :data-type="data_type" />
        <!-- <div
          class="img"
          :style="{ backgroundImage: `url(${getImg(item.images)})` }"
        ></div>
        <div class="text">
          <span class="title">{{ item.name }}</span>
          <span class="author">{{ item.student.name }}</span>
          <div class="icons">
            <span class="zan" @click.stop="likeWorkEvent(item.pk)">
              <img
                :src="
                  `${item.islike ? images.like_select : images.like_unselect}`
                "
              />
              {{ item.likes }}
            </span>
            <span class="zan">
              <img :src="images.eye"/>
              {{ item.browser_count }}
            </span>
          </div>
        </div> -->
      </div>
    </div>

    <div class="swiper-next-btn" @click="btnEvent('next')">
      <img class="icon" :src="images.more_right">
    </div>
  </div>
</template>

<script>

import { 
  IMG_WORK__LIKE_SELECT, 
  IMG_WORK__LIKE_UNSELECT,
  IMG_ARROW_ORANGE_LEFT, 
  IMG_ARROW_ORANGE_RIGHT,
  IMG_EYE
} from "../assets";
import { Utils } from "../utils";

import WorkItem from "./scratch/components/WorkItem.vue";

import { types as WorkTypes } from "../store/modules/work";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "WorkListTop",
  components: {
    WorkItem
  },
  props: {
    tag:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      images: {
        like_select: IMG_WORK__LIKE_SELECT,
        like_unselect: IMG_WORK__LIKE_UNSELECT,
        more_left:IMG_ARROW_ORANGE_LEFT,
        more_right:IMG_ARROW_ORANGE_RIGHT,
        eye: IMG_EYE
      },
      index: 0,  //一组第一个元素的下标,
      count: 7,  //一组放多少个元素
      data: [],
    };
  },
  watch: {
    top_data(value){
      if(value.length > 0){
        this.data = value.slice(this.index, this.index + this.count)
        this.index = this.index + this.data.length;
        // console.log(this.data, "applab_data", this.index, this.index+this.count)
      }
    }
  },
  computed: {
    ...mapState({
      top_data(state){
        return this.tag === 'applab' ? state.work.applab_data.data : state.work.top_data.data
      },
      page(state){
        return this.tag === 'applab' ? state.work.applab_data.page : state.work.top_data.page
      },
      loadMore(state){
        return this.tag === 'applab' ? state.work.applab_data.load_more : state.work.top_data.load_more
      }
    })
  },

  methods: {
    ...mapActions({
      fetchTopWorks: WorkTypes.FETCH_LIST_MY_WORKS,
      fetchLikeWorkEvent: WorkTypes.FETCH_LIKE_EVENT
    }),
    ...Utils,

    btnEvent(tag){
      var temp_data = this.top_data
      if(tag === 'next'){
        // 下一组
        if(this.index >= temp_data.length){
          // console.log("当前已经是最后一组了[已有数据源]", this.index);
          if(this.loadMore){
            // console.log("请求下一页数据")
            this.loadNextData()
          }else{
            // console.log("数据加载完毕")
          }
        }else{
          this.data = temp_data.slice(this.index, this.index+this.count);
          this.index = this.index + this.data.length
          // console.log(this.index, "next")
        }
      }else if(tag === 'prev'){
        // 上一组
        if(this.index - this.data.length <= 0){
          console.log("当前已经是第一组了");
        }else{
          let lastIndex = this.index - this.data.length;
          let firstIndex = lastIndex - this.count;
          this.index = lastIndex;
          // console.log("prev",firstIndex, lastIndex, this.index)

          this.data = temp_data.slice(firstIndex, lastIndex);
        }
      }
    },
    //点赞作品
    likeWorkEvent(item) {
      this.fetchLikeWorkEvent({pk:item.pk, data_type: this.data_type});
    },
    //作品详情页
    jumpToWorkDetail(item) {
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${item.pk}`,
        "_blank"
      );
    },

    loadNextData(){
      let dic = {
        page: this.page + 1,
        page_size:this.count,
        work_type: this.tag,
        data_type: this.data_type
      }
      dic["owner"] = "88820190449"
      this.fetchTopWorks(dic)
    }
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
    // console.log(this.images)
    // console.log(this.data)
    let data_type = ""
    if(this.tag === 'applab'){
      data_type = "top_applab"
    }else if(this.tag === 'scratch3'){
      data_type = "top_scratch3"
    }
    this.data_type = data_type;
    // 国外搬运(数据暂存在 top_data )
    let dic = {
      page: 1,
      page_size:this.count,
      work_type: this.tag,
      data_type: this.data_type
    }
    dic["owner"] = "88820190449"
    this.fetchTopWorks(dic)

    // 精选
    // dic["top"] = true
    // this.fetchTopWorks(dic)
  }
};
</script>

<style lang="less" scoped>
.contentView__works {
  display: flex;
  flex-direction: row;
  width: calc(100% - 0px);
  margin: auto;
  // padding-left: 10px;
  // padding-right: 10px;
  // background-color: red;
  margin-bottom: 10px;
  height: 184px;
}

.swiper-prev-btn,
.swiper-next-btn {
  height: 100%;
  text-align: center;
  color: #6b45e1;
  // background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .icon{
    width: 40px;
  }
}
.swiper-prev-btn{
  margin-left: -45px;
}
.swiper-next-btn{
  margin-right: -45px;
}
.swiper-items {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: row;
  margin-left: 5px;
  flex-wrap: wrap;
  overflow: hidden;
  .swiper-item {
    width: calc(100% / 7 - 15px);
    // height: 100%;
    background-color: #ffffff;
    border-radius: 5px;
    margin-right: 5px;

    display: flex;
    flex-direction: row;
    padding: 5px;
    cursor: pointer;
    .img {
        width: 80px;
    height: 80px;
    border-radius: 5px;
      background-color: #e1e1e1;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .text {
      padding-left: 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
          flex: 1;

      .title {
        font-size: 13px;
        color: #333333;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
      }
      .author {
        font-size: 13px;
        color: #666666;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
      }
      .icons{
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .zan {
        flex: 1;
        font-size: 13px;
        color: #999999;
        display: flex;
        flex-direction: row;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
        // justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          height: 14px;
          margin-right: 3px;
        }
      }
    }
  }
}
</style>
